import ControlFeesPage from "./controlFees";

export default ControlFeesPage;